module.exports = __webpack_public_path__ + "img/closed-eye.20f1c3c3.svg";